export enum ReportsRouteNames {
  REPORTS = 'Reports',
  DISCOUNTS = 'Reports/discounts',
  SALES_SUMMARY = 'Reports/salesSummary',
  SALES_DISTRIBUTION = 'Reports/salesDistribution',
  SALES_MIX = 'Reports/salesMix',
  SALES_MIX_2_0 = 'Reports/salesMix2_0',
  REFUND = 'Reports/refundReport',
  TERMINAL_SALES = 'Reports/terminalSales',
  SALES_READING = 'Reports/salesReading',
  REPORTING_DIAGNOSTICS = 'Reports/reportingDiagnostics',
}
